const BasicLabel = (props) => <label className="block text-sm font-medium text-gray-700 dark:text-gray-400" {...props}/>

export default BasicLabel;